import { Component, Input, SimpleChanges } from '@angular/core';
import moment from 'moment';

@Component({
  selector: 'app-cancellation-policy-summary',
  templateUrl: './cancellation-policy-summary.component.html',
  styleUrls: ['./cancellation-policy-summary.component.scss']
})
export class CancellationPolicySummaryComponent {
  @Input() cancelPolicies: any;
  @Input() checkInDate: string;
  @Input() currency: string;
  @Input() exchangeRate: number | undefined;
  timeZone: string = '';

  constructor(){}

  ngOnInit() {
    if(this.cancelPolicies){
      this.getTimezoneFromPolicies();
      this.convert3rdPolicy();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if(this.cancelPolicies){
      this.getTimezoneFromPolicies();
      this.convert3rdPolicy();
    }
  }

  convert3rdPolicy(){
    if (this.cancelPolicies.length === 2) {
      const [first, second] = this.cancelPolicies;
    
      const isFirstItemMatch = first.from_day === null && first.to_day === 0;
      const isSecondItemMatch = second.from_day === 0 && second.to_day === 0;
    
      if (isFirstItemMatch && isSecondItemMatch) {
        this.cancelPolicies = [second]; // Giữ lại item 2
      }
    }
  }

  getDateBefore(daysAgo: number, baseDate: string): string {
    return moment(baseDate).subtract(daysAgo, 'days').format('YYYY-MM-DD');
  }
  
  getTimezoneFromPolicies() {
    const policyWithTime = this.cancelPolicies.find((p: { time: any; }) => p.time);
    if (!policyWithTime) return;
  
    const timeStr = policyWithTime.time;
    const match = timeStr.match(/([+-])(\d{2}):?(\d{2})?/);
  
    if (!match) return;
  
    const sign = match[1] === '+' ? '+' : '-';
    const hours = parseInt(match[2], 10);
  
    this.timeZone = `(UTC${sign}${hours})`;
  }

  formatCurrency = (price: number, currency: string) => {
    const validPrice = typeof price === 'number' && !isNaN(price);
    const validRate = typeof this.exchangeRate === 'number' && !isNaN(this.exchangeRate);
  
    const finalPrice = validPrice && validRate ? price * (this.exchangeRate || 1) : 0;
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency,
    }).format(finalPrice);
  };
}
